import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useLocation, useNavigate } from 'react-router';
import useApi from '../../../api/useApi';
import { ArticleGet, ResourceGet } from '../../../api/orgService';
import { toast } from 'react-toastify';
import SkeletonList from '../../sections/SkeletonList';

function ResourceAdminList() {
    const navigate = useNavigate()
        const location = useLocation()
        const [AllResources,setAllResources] =useState([])
        // const [nextPageUrl, setNextPageUrl] = useState('http://localhost:8000/api/articles/');
        const [loading, setLoading] = useState(false);
    
        const { request: getAllResources, data:resourcesData, error:resorcesError,isLoading:getResourceLoading} = useApi(ResourceGet);
    
              useEffect(() => {
                getAllResources();
                     // eslint-disable-next-line
                }, []);
                
                useEffect(()=>{
                  if (resourcesData?.status===200) {
                    setAllResources(resourcesData?.data);
                  }
                // eslint-disable-next-line
                },[resourcesData])
        
              
                // useEffect(()=>{
                //     if(location?.state?.refresh==="org"){
                //       getAllResources();
                //     }
                //   // eslint-disable-next-line
                //   },[location?.state])
              
                useEffect(()=>{
                    if(resorcesError){
                        toast.error(`${JSON.stringify(resorcesError?.response?.data,null,2)}`,{position: "top-center"});
                  }
                },[resorcesError]) 

    const rows = [
        { id: 1, title: 'Project Test', description: 'the Community version', link: "/staff/article/detail"},
        { id: 2, title: 'Data Grid Pro', description: 'the Pro version', link: "/staff/article/detail?id=1" },
        { id: 3, title: 'Data Grid Premium', description: 'the Premium version', link: "/staff/article/detail?id=1" },
      ];
      
    const columns = [
        { field: 'id', headerName: 'Resource Number', width: 200 },
        { field: 'title', headerName: 'Resource Name', width: 200 },
        { field: 'description', headerName: 'Resource Description', width: 300 },
        { field: 'link', headerName: 'View Details', width: 300,
            renderCell: (params) => (
                // <Link
                //   href={params.value}
                //   style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
                // >
                //   View details →
                // </Link>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate(`/staff/resource/detail/${params.row.id}/`, {state: { resourceId: params.row.id, resourceName: params.row.title }})}
                    sx={{
                    textTransform: 'none',
                    backgroundColor: '#1976d2',
                    '&:hover': { backgroundColor: '#115293' },
                    }}
                >
                    View Details →
                </Button>
              ),
         }
    
      ];
    
      if(getResourceLoading){
            return (
              <SkeletonList/>
            )
          }
  return (
    <div style={{ height: '80%', width: '100%' }}>
      <DataGrid rows={AllResources?.results} columns={columns} />
    </div>
  )
}

export default ResourceAdminList